import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const user_key = 'user_sh_jpn'
const game_key = 'game_sh_jpn'
const store = new Vuex.Store({
    state: {
        userInfo: {
            token: '',
            account: '',
            appId: 0
        },
        gameInfo: {
            appId: 10062,
            id: 512
        },
        games: [
            {
                id: 512,
                appId: 10062,
                name: 'エターナルドラグーン：焔の誓い',
                apple: {

                    clientId: "com.xiaoma.signin", // This is the service ID we created.
                    redirectURI: "https://api.eternaldragoon.com/v1/web/official/apple/auth/10062?region=jpn", // As registered along with our service ID
                },
                facebook: {
                    appId: '1636237373927751'
                },
                google: {
                    clientId: '215962329298-a4n88qivehv8ua7mkmmsa0tk6q5b58c2.apps.googleusercontent.com'
                },
                payments: [

                    // {
                    //     id: 17,
                    //     name: 'alipay',
                    //     payMethod: 'alipayplus--PAYPAY',
                    //     key: 'adyen--alipay'
                    // },
                    // 申请被拒
                    // {
                    //     id: 1,
                    //     name: 'konbini',
                    //     payMethod: 'airwallex--konbini',
                    //     key: 'airwallex--konbini'
                    // },
                    // {
                    //     id: 2,
                    //     name: 'payeasy',
                    //     payMethod: 'airwallex--payeasy',
                    //     key: 'airwallex--payeasy'
                    // },

                    // {
                    //     id: 3,
                    //     name: 'カード',
                    //     payMethod: 'airwallex--card',
                    //     key: 'airwallex--visa'
                    // },
                    // {
                    //     id: 5,
                    //     name: 'UnionPay',
                    //     payMethod: 'airwallex--card',
                    //     key: 'airwallex--unionpay'
                    // },
                    // {
                    //     id: 8,
                    //     name: 'Apple Pay',
                    //     payMethod: 'airwallex--applepay',
                    //     key: 'airwallex--applepay'
                    // },
                    // {
                    //     id: 9,
                    //     name: 'Google Pay',
                    //     payMethod: 'airwallex--googlepay',
                    //     key: 'airwallex--googlepay'
                    // },


                   {
                        id: 5,
                        name: 'カード',
                        payMethod: 'adyen--card',
                        key: 'adyen--jcb'
                    },
                    {
                        id: 17,
                        name: 'UnionPay',
                        payMethod: 'adyen--card',
                        key: 'adyen--unionpay'
                    },
                    {
                        id: 8,
                        name: 'Apple Pay',
                        payMethod: 'airwallex--applepay',
                        key: 'airwallex--applepay'
                    },

                    // {
                    //     id: 15,
                    //     name: 'Apple Pay',
                    //     payMethod: 'adyen--applepay',
                    //     key: 'adyen--applepay'
                    // },
                    // {
                    //     id: 16,
                    //     name: 'Google Pay',
                    //     payMethod: 'adyen--googlepay',
                    //     key: 'adyen--googlepay'
                    // },
                    // {
                    //     id: 17,
                    //     name: 'diners',
                    //     payMethod: 'adyen--diners',
                    //     key: 'adyen--diners'
                    // },
                    // {
                    //     id: 17,
                    //     name: 'discoverpay',
                    //     payMethod: 'adyen--discover',
                    //     key: 'adyen--discoverpay'
                    // },
                    

                    // {
                    //     id: 18,
                    //     name: 'WeChat Pay',
                    //     payMethod: 'adyen--wechatpayWeb',
                    //     key: 'adyen--wechatpay'
                    // },

                    // {
                    //     id: 18,
                    //     name: 'Alipay Pay',
                    //     payMethod: 'adyen_one',
                    //     key: 'adyen--wechatpay'
                    // },
                    // {
                    //     id: 18,
                    //     name: 'Alipay Pay',
                    //     payMethod: 'adyen--alipay_hk',
                    //     key: 'adyen--wechatpay'
                    // },

                    // {
                    //     id: 19,
                    //     name: 'American Express',
                    //     payMethod: 'adyen--american-express',
                    //     key: 'adyen--american-express'
                    // },
                    // {
                    //     id: 20,
                    //     name: 'konbini',
                    //     payMethod: 'adyen--konbini',
                    //     key: 'adyen--konbini'
                    // },
                    // {
                    //     id: 21,
                    //     name: 'payeasy ATM',
                    //     payMethod: 'adyen--payeasy-atm',
                    //     key: 'adyen--payeasy-atm'
                    // },
                    // {
                    //     id: 22,
                    //     name: 'payeasy online banking',
                    //     payMethod: 'adyen--payeasy-online-banking',
                    //     key: 'adyen--payeasy-online-banking'
                    // },
                    // {
                    //     id: 23,
                    //     name: 'paypay',
                    //     payMethod: 'adyen--paypay',
                    //     key: 'adyen--paypay'
                    // },
                    // {
                    //     id: 24,
                    //     name: 'paypay',
                    //     payMethod: 'alipay--paypay',
                    //     key: 'alipay--paypay'
                    // },

                    
                    {
                        id: 25,
                        name: 'BitCash',
                        payMethod: 'gash--COPBTC01',
                        key: 'gash--bitcash'
                    },
                    {
                        id: 25,
                        name: 'NetCash',
                        payMethod: 'gash--COPNTC01',
                        key: 'gash--netcash'
                    },
                    {
                        id: 25,
                        name: 'WebMoney',
                        payMethod: 'gash--COPWBM01',
                        key: 'gash--webmoney'
                    },
                     

                    {
                        id: 25,
                        name: 'paypay',
                        payMethod: 'xsolla--3669',
                        key: 'xsolla--paypay'
                    },

                    // {
                    //     id: 17,
                    //     name: 'alipay',
                    //     payMethod: 'adyen--alipay',
                    //     key: 'adyen--alipay'
                    // },

                ]
            }
        ]
    },
    mutations: {
        initStore(state) {
            let a = JSON.parse(localStorage.getItem(user_key))
            console.log('init->', a)
            if (a) {
                console.log('init2->', a)
                this.commit('loginLocal', a)
            }
            let b = JSON.parse(localStorage.getItem(game_key))
            console.log('init->', b)
            if (b) {
                console.log('init2->', b)
                this.commit('setGameInfo', b)
            } else {
                this.commit('setGameInfo', state.games[0])
            }
        },
        loginLocal(state, payload) {
            console.log('loginLocal->', payload)
            state.userInfo = Object.assign(state.userInfo, payload)
            localStorage.setItem(user_key, JSON.stringify(state.userInfo));
        },
        setGameInfo(state, payload) {
            state.gameInfo = payload //Object.assign(state.gameInfo, payload)
            localStorage.setItem(game_key, JSON.stringify(state.gameInfo));
        },
        logout(state) {
            state.userInfo = {
                token: '',
                account: '',
                appId: 0
            }
            localStorage.setItem(user_key, '{}');
        }
    }
})
export default store